module.exports = __webpack_public_path__ + "img/IQ.c3104587.svg";